import _reduce from 'lodash/reduce';
import _assign from 'lodash/assign';
import { parseHiddenJSON } from '@zillow/hidden-block';
import { trackEvent, setdim } from '@zillow/universal-analytics';
import query from '@zillow/parsed-query';

var config = parseHiddenJSON('.zmm-api-config');
var abs = _assign({}, config, query);
var dynamicallyStartedTrialsRunning = {};

/**
 * AB testing utility for ZGMI experiments.
 * Currently setup to use Google Optimize and relying on window.optimize object to identify active experiments.
 * Refer to https://zgmi.pages.zgtools.net/documentation/ab-test for setup guidelines.
 */
var abtest = {
  getTreatment: function getTreatment(trial, defaultTreatment) {
    var _global, _global$window, _global$window$e2eExp;
    if (defaultTreatment === void 0) {
      defaultTreatment = 'CONTROL';
    }
    return (
      // ZGMIAIR-2473 e2eExperiments is reserved for overriding test in cypress
      ((_global = global) === null || _global === void 0 ? void 0 : (_global$window = _global.window) === null || _global$window === void 0 ? void 0 : (_global$window$e2eExp = _global$window.e2eExperiments) === null || _global$window$e2eExp === void 0 ? void 0 : _global$window$e2eExp[trial]) || abs[trial] || defaultTreatment
    );
  },
  // treat Original as Control
  dynamicallyStartTrial: function dynamicallyStartTrial(event) {
    /**
     * dataLayer is the variable set up by Optimize that allows us to push objects to it that can be consumed
     * by our experiments in order to dynamically change the experiments.
     */
    if (!dynamicallyStartedTrialsRunning[event]) {
      var _window$dataLayer;
      (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
        event: event
      });
      var currentABs = Object.keys(abs);
      abs = _assign(abs, window.optimize);
      Object.keys(abs) // Names of all AB test trials
      .filter(function (key) {
        return currentABs.indexOf(key) === -1;
      }) // Filter out the trials that have already been started and tracked in the current user session
      .forEach(function (key) {
        trackEvent({
          category: 'Mortgages',
          action: "AB Test = " + key,
          label: abs[key]
        });
      });
      dynamicallyStartedTrialsRunning[event] = true;
    }
  },
  waitOnOptimize: function waitOnOptimize() {
    if (typeof window !== 'undefined' && window.__onOptimizeLoaded) {
      return new Promise(function (resolve) {
        window.__onOptimizeLoaded(function () {
          var _console, _console$debug;
          var currentABs = Object.keys(abs);
          var trials = window.optimize || {};
          var abAssignments = [];
          Object.keys(trials).filter(function (key) {
            return currentABs.indexOf(key) === -1;
          }).forEach(function (key) {
            abs[key] = trials[key];
            trackEvent({
              category: 'Mortgages',
              action: "AB Test = " + key,
              label: trials[key]
            });
            abAssignments.push({
              trial: key,
              treatment: trials[key]
            });
          });
          // eslint-disable-next-line no-console
          (_console = console) === null || _console === void 0 ? void 0 : (_console$debug = _console.debug) === null || _console$debug === void 0 ? void 0 : _console$debug.call(_console, 'Optimize Variants', trials);
          setdim({
            dimension132: JSON.stringify(trials)
          });
          setdim({
            abAssignments: abAssignments
          }, {
            integrations: {
              GaPlugin: false
            }
          });
          resolve();
        });
      });
    }
    return Promise.resolve();
  },
  /**
   * @return array of objects with properties:
   *      - name
   *      - treatment
   */
  getActiveExperiments: function getActiveExperiments() {
    return _reduce(abs, function (result, treatment, experiment) {
      if (treatment !== 'CONTROL') {
        result.push({
          name: experiment,
          treatment: treatment
        });
      }
      return result;
    }, []);
  }
};

export default abtest;
